// ProtectedRoute.js
import React from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = ({
  requiredPermission,
  redirectPathAuth = "/login",
  redirectPathPermission = "/unauthorized",
}) => {
  const { isAuthenticated, isLoading, permissions } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return (
      <Navigate to={redirectPathAuth} state={{ from: location }} replace />
    );
  }

  // If a required permission is provided, check if the user has it.
  if (
    requiredPermission &&
    (!permissions || !permissions[requiredPermission])
  ) {
    return <Navigate to={redirectPathPermission} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
